import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import { useTranslations } from "use-intl";
import { useFilterByRequiredModules } from "@/modules/common/features/navigation/utils/filter-by-required-modules";
import { useFilterByPermissions } from "@/modules/common/features/navigation/utils/filter-by-permission";
import { useFilterByIsManager } from "@/modules/common/features/navigation/utils/filter-by-is-manager";
import { itemsToMenuItems } from "@/modules/common/features/navigation";
import { filterMenuItems } from "@/modules/common/features/navigation/utils/filter-menu-items-recursively";

export function usePrepareMenuItems({ items }: { items: NavigationItem[] }) {
  const t = useTranslations("Navigation");
  const filterByRequiredModules = useFilterByRequiredModules();
  const filterByPermissions = useFilterByPermissions();
  const filterByIsManager = useFilterByIsManager();

  let filteredItems = items;
  filteredItems = filterMenuItems(filteredItems, filterByRequiredModules);
  filteredItems = filterMenuItems(filteredItems, filterByPermissions);
  filteredItems = filterMenuItems(filteredItems, filterByIsManager);

  return itemsToMenuItems(filteredItems, t);
}
